import React from "react";
import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { _t, isEn } from "../../app/i18n/i18n";
import { FaIcon } from "lib/FaIcon";

export const NotFound = () => (
  <InfoIconCard
    title={isEn() && "Page not found"}
    icon="far fa-compass fa-4x fa-spin"
    body={
      <section>
        <div className="font-weight-bold mb-4">404</div>
        <div className="mx-auto my-auto">{_t("The page you requested could not be found.")}</div>
        <small className="d-block mb-3">{window.location.href}</small>
      </section>
    }
    footer={<HomeButton />}
  />
);

export const InfoCard = ({ children }) => <Card className="maxw-400 mt-3 shadow">{children}</Card>;

export const InfoIconCard = ({ title, icon, body, footer, className }) => (
  <Card className={"maxw-400 mt-3 shadow " + className}>
    {title && (
      <Card.Header>
        <Card.Title>{title}</Card.Title>
      </Card.Header>
    )}
    {body && (
      <Card.Body className="text-center py-4">
        {icon && <FaIcon icon={icon} />}
        {body}
      </Card.Body>
    )}
    {footer && <Card.Footer>{footer}</Card.Footer>}
  </Card>
);

export const HomeButton = () => (
  <Link to="/" className="d-block text-center">
    <Button>
      {_t("To Home Page")}
      <FaIcon icon="fas fa-home ml-2" align="top" />
    </Button>
  </Link>
);
